// extracted by mini-css-extract-plugin
module.exports = {"Policy":"Policy___EEB-z","PolicyGrammarName":"PolicyGrammarName___20nPk"};